import React, { Component } from 'react';
class FoodJi extends Component {

  render() { 
    return ( 
      <div className='content'>
        <span>FoodJi</span>
      </div>
     );
  }
}
 
export default FoodJi;